var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerContractorJobsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44.353,
    height: 53.382,
    viewBox: "0 0 44.353 53.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1991",
    "data-name": "Rectangle 1991",
    width: 40.493,
    height: 43.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1992",
    "data-name": "Rectangle 1992",
    width: 32.2,
    height: 39.617,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1994",
    "data-name": "Rectangle 1994",
    width: 32.2,
    height: 39.617,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1995",
    "data-name": "Rectangle 1995",
    width: 13.728,
    height: 14.392,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1996",
    "data-name": "Rectangle 1996",
    width: 11.276,
    height: 3.409,
    fill: "#d2e4fd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    "data-name": "Rectangle 1997",
    width: 25.444,
    height: 25.444,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 26.248,
    height: 26.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 2.581,
    height: 2.486,
    fill: "#37dba5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    width: 13.65,
    height: 14.537,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22102",
    "data-name": "Group 22102",
    transform: "translate(-478.938 -108.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M44.353,346.328c0,.945-9.929,1.712-22.176,1.712S0,347.273,0,346.328s9.929-1.712,22.176-1.712,22.176.766,22.176,1.712",
    transform: "translate(478.938 -186.206)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22074",
    "data-name": "Group 22074",
    transform: "translate(481.153 113.684)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22073",
    "data-name": "Group 22073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22072",
    "data-name": "Group 22072",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M25.018,69.71,3.025,56.67a.372.372,0,0,1-.13-.51L20.649,26.214a.372.372,0,0,1,.51-.13l21.994,13.04a.373.373,0,0,1,.13.51L25.528,69.579a.372.372,0,0,1-.51.13",
    transform: "translate(-2.842 -26.031)",
    fill: "#3e479b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M22.176,63.74.182,50.7a.372.372,0,0,1-.13-.51L17.807,20.244a.372.372,0,0,1,.51-.13L40.31,33.153a.372.372,0,0,1,.13.51L22.686,63.609a.372.372,0,0,1-.51.13",
    transform: "translate(480.582 92.423)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22077",
    "data-name": "Group 22077",
    transform: "translate(483.625 116.185)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22076",
    "data-name": "Group 22076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22075",
    "data-name": "Group 22075",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M40.594,78.085,15.449,73.45a.372.372,0,0,1-.3-.433L21.461,38.78a.372.372,0,0,1,.433-.3L47.04,43.116a.372.372,0,0,1,.3.433L41.027,77.787a.372.372,0,0,1-.433.3",
    transform: "translate(-15.144 -38.475)",
    fill: "#3e479b"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1993",
    "data-name": "Rectangle 1993",
    width: 35.558,
    height: 26.313,
    transform: "translate(483.027 150.13) rotate(-79.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22080",
    "data-name": "Group 22080",
    transform: "translate(483.088 115.222)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22079",
    "data-name": "Group 22079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22078",
    "data-name": "Group 22078",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M37.92,73.294,12.775,68.659a.372.372,0,0,1-.3-.433l6.311-34.237a.372.372,0,0,1,.433-.3l25.145,4.635a.372.372,0,0,1,.3.433L38.353,73a.372.372,0,0,1-.433.3",
    transform: "translate(-12.47 -33.684)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M127.669,71.394a.193.193,0,0,1-.037,0l-6.294-1.16a.2.2,0,1,1,.073-.4L127.706,71a.2.2,0,0,1-.036.4",
    transform: "translate(383.765 52.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M125.826,81.4a.192.192,0,0,1-.037,0l-6.294-1.16a.2.2,0,0,1,.073-.4L125.862,81a.2.2,0,0,1-.036.4",
    transform: "translate(385.237 44.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M123.822,92.27a.193.193,0,0,1-.037,0l-6.294-1.16a.2.2,0,1,1,.073-.4l6.294,1.16a.2.2,0,0,1-.036.4",
    transform: "translate(386.838 35.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22083",
    "data-name": "Group 22083",
    transform: "translate(489.808 115.72)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22082",
    "data-name": "Group 22082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22081",
    "data-name": "Group 22081",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M57.014,50.544,46.229,48.556a.4.4,0,0,1-.323-.469l2.138-11.6a.4.4,0,0,1,.469-.323L59.3,38.154a.4.4,0,0,1,.323.469l-2.138,11.6a.4.4,0,0,1-.469.323",
    transform: "translate(-45.899 -36.159)",
    fill: "#3e479b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M57.043,50.018l-10.281-1.9a.4.4,0,0,1-.323-.469l2.024-10.98a.4.4,0,0,1,.469-.323l10.281,1.9a.4.4,0,0,1,.323.469L57.512,49.7a.4.4,0,0,1-.469.323",
    transform: "translate(443.482 79.413)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22086",
    "data-name": "Group 22086",
    transform: "translate(491.755 115.755)",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22085",
    "data-name": "Group 22085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22084",
    "data-name": "Group 22084",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M66.659,39.744,55.585,37.7l.193-1.048a.391.391,0,0,1,.455-.314l10.318,1.9a.377.377,0,0,1,.3.439Z",
    transform: "translate(-55.585 -36.334)",
    fill: "#d2e4fd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11284",
    "data-name": "Path 11284",
    d: "M64.562,38.55a1.3,1.3,0,0,1-.236-.022l-.153-.028a1.5,1.5,0,0,1-1.2-1.749l.387-2.1a.3.3,0,0,1,.593.109l-.387,2.1a.9.9,0,0,0,.721,1.047l.153.028a.7.7,0,0,0,.813-.56l.979-5.311a.721.721,0,0,0-.578-.84l-.262-.048a.766.766,0,0,0-.891.614l-.024.131a.3.3,0,0,1-.593-.109l.024-.131a1.37,1.37,0,0,1,1.594-1.1l.262.048a1.325,1.325,0,0,1,1.062,1.542l-.979,5.311a1.3,1.3,0,0,1-1.279,1.066",
    transform: "translate(430.291 84.034)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11285",
    "data-name": "Path 11285",
    d: "M59.833,44.379h-.018L55.8,43.637a.1.1,0,1,1,.037-.2l4.018.741a.1.1,0,0,1-.018.2",
    transform: "translate(436.066 73.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11286",
    "data-name": "Path 11286",
    d: "M60.076,135.768a.194.194,0,0,1-.037,0l-19.233-3.545a.2.2,0,0,1,.073-.4l19.233,3.545a.2.2,0,0,1-.036.4",
    transform: "translate(448.108 3.128)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11287",
    "data-name": "Path 11287",
    d: "M53.235,172.882a.193.193,0,0,1-.037,0l-19.233-3.545a.2.2,0,1,1,.073-.4l19.233,3.545a.2.2,0,0,1-.036.4",
    transform: "translate(453.575 -26.527)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11288",
    "data-name": "Path 11288",
    d: "M46.514,152.455a.192.192,0,0,1-.037,0l-9.092-1.676a.2.2,0,1,1,.073-.4l9.092,1.676a.2.2,0,0,1-.036.4",
    transform: "translate(450.842 -11.699)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M52.747,118.646a.192.192,0,0,1-.037,0l-9.092-1.676a.2.2,0,0,1,.073-.4l9.092,1.676a.2.2,0,0,1-.036.4",
    transform: "translate(445.862 15.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M98.7,161.925a.178.178,0,0,1-.037,0L90,160.325a.2.2,0,1,1,.073-.4l8.663,1.6a.2.2,0,0,1-.036.4",
    transform: "translate(408.803 -19.329)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22089",
    "data-name": "Group 22089",
    transform: "translate(483.795 111.18)",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22088",
    "data-name": "Group 22088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22087",
    "data-name": "Group 22087",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M28.71,11.567A12.722,12.722,0,1,0,41.432,24.289,12.722,12.722,0,0,0,28.71,11.567",
    transform: "translate(-15.988 -11.567)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22095",
    "data-name": "Group 22095",
    transform: "translate(483.393 110.375)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22094",
    "data-name": "Group 22094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22093",
    "data-name": "Group 22093",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M27.112,35.815A13.124,13.124,0,1,1,40.236,22.691,13.139,13.139,0,0,1,27.112,35.815m0-25.444a12.32,12.32,0,1,0,12.32,12.32,12.334,12.334,0,0,0-12.32-12.32",
    transform: "translate(-13.988 -9.567)",
    fill: "#3e479b"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M31.961,24.962a.6.6,0,0,1,.06-.049,14.881,14.881,0,1,0-2.721,2.71L31.018,25.9ZM20.268,28.569A12.722,12.722,0,1,1,32.99,15.847,12.722,12.722,0,0,1,20.268,28.569",
    transform: "translate(476.249 107.652)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M19.469,30.095A15.047,15.047,0,1,1,34.516,15.048a14.9,14.9,0,0,1-3.134,9.189l-.038.037a.371.371,0,0,0-.039.031l-2.68,2.678a14.9,14.9,0,0,1-9.156,3.112M19.469.4a14.645,14.645,0,0,0,0,29.29,14.5,14.5,0,0,0,8.9-3.021l2.651-2.651a.574.574,0,0,1,.06-.051,14.5,14.5,0,0,0,3.034-8.922A14.661,14.661,0,0,0,19.469.4m0,27.568A12.923,12.923,0,1,1,32.392,15.048,12.938,12.938,0,0,1,19.469,27.971m0-25.444A12.521,12.521,0,1,0,31.99,15.048,12.535,12.535,0,0,0,19.469,2.527",
    transform: "translate(477.049 108.451)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M125.74,126.275l-.576-.576a.568.568,0,0,1,0-.8l-1.717,1.718-.028.028a.567.567,0,0,0,0,.8l.7.7a13.664,13.664,0,0,1,1.623-1.869",
    transform: "translate(382.103 8.659)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M132.1,120.494a.567.567,0,0,0,0,.8l.576.576a15.84,15.84,0,0,1,1.839-1.652l-.669-.669a.588.588,0,0,0-.8,0Z",
    transform: "translate(375.166 13.062)",
    fill: "#4c65ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22098",
    "data-name": "Group 22098",
    transform: "translate(507.101 132.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22097",
    "data-name": "Group 22097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22096",
    "data-name": "Group 22096",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M132.1,120.494a.567.567,0,0,0,0,.8l.576.576a15.84,15.84,0,0,1,1.839-1.652l-.669-.669a.588.588,0,0,0-.8,0Z",
    transform: "translate(-131.936 -119.387)",
    fill: "#37dba5"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M141.452,133.438,131,122.869c-.038-.038-.152.012-.317.124a15.86,15.86,0,0,0-1.839,1.652,13.658,13.658,0,0,0-1.622,1.868c-.075.126-.1.213-.071.246L137.6,137.329a2.7,2.7,0,0,0,3.849,0,2.772,2.772,0,0,0,0-3.891",
    transform: "translate(379.002 10.29)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22101",
    "data-name": "Group 22101",
    transform: "translate(507.601 133.146)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22100",
    "data-name": "Group 22100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22099",
    "data-name": "Group 22099",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M147.273,133.437l-10.454-10.568c-.141-.142-1.332.925-2.355,1.98-.87.9,11.747,13.554,12.809,12.48a2.772,2.772,0,0,0,0-3.891",
    transform: "translate(-134.421 -122.855)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerContractorJobsIcon);
export default __webpack_public_path__ + "static/media/banner-contractor-jobs-icon.7919108a3798659628f71a9a07cb8ef7.svg";
export { ForwardRef as ReactComponent };